import { RemovedUserResponse } from "../../api-models/response/user/UserResponse";
import { DataGridStorageModel } from "../../components/datatable/DataGridStorage";
import { Column, ColumnType, RowItemData } from "../../components/datatable/interfaces";
import { SupportTag } from "../../components/grid-tag/Tags";
import { endpoints } from "../api/ApiEndpoints";

class RemovedUser implements RowItemData {
  id: number;
  private userName: string;
  private anonymization: string;
  private isSupportAccount: boolean;

  constructor(userResponse: RemovedUserResponse) {
    this.id = userResponse.id;
    this.userName = userResponse.userName;
    this.anonymization = userResponse.anonymization;
    this.isSupportAccount = userResponse.isSupportAccount;
  }
  get displayValues() {
    return {
      userName: {
        toDisplay: this.userName,
        child: this.isSupportAccount ? SupportTag : null
      },
      anonymization: {
        toDisplay: this.anonymization
      },
    }
  }
}

export const RemovedUsersStorage = DataGridStorageModel.named("RemovedUsersStorage")
  .views(() => ({
    get tableColumns(): Column[] {
      return [
        {
          key: "userName",
          name: "general.user-name",
          type: ColumnType.String,
          sortable: true,
          filterable: true,
        },
        {
          key: "anonymization",
          name: "general.removed-users.list-header.anonymization",
          type: ColumnType.String,
          sortable: true,
          filterable: true,
        },
      ];
    },
  }))
  .actions((self) => {
    return {
      mapItem(item: RemovedUserResponse): RowItemData {
        return new RemovedUser(item);
      },
      
      afterCreate() {
        self.defaultSort = { field: "userName", sort: "asc" };
        self.gridColumns = self.tableColumns;
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("users_removed_all");
      endpoint.queryParams = self.getDataQuery();
      return endpoint;
    },
  }));
